import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const TEAM_IMG = "https://images.unsplash.com/photo-1608064626410-21c647573628?crop=entropy&cs=srgb&fm=jpg&w=800&q=80";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] } },
};

export default function AboutUs() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="about" data-testid="about-us" className="py-24 md:py-32 lg:py-40 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="relative order-2 lg:order-1"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img src={TEAM_IMG} alt="El Salvador landscape" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-4 -left-4 w-24 h-24 border border-[#C5A059]/20" />
          </motion.div>

          {/* Text */}
          <motion.div
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={{ visible: { transition: { staggerChildren: 0.12 } } }}
            className="order-1 lg:order-2"
          >
            <motion.p variants={fadeUp} className="font-sans text-[#C5A059] text-[10px] md:text-xs tracking-[0.25em] uppercase mb-4">
              Our Story
            </motion.p>
            <motion.h2 variants={fadeUp} className="font-serif text-white text-4xl md:text-5xl font-light tracking-tight mb-8">
              About <span className="italic">Us</span>
            </motion.h2>
            <motion.p variants={fadeUp} className="font-serif text-white/70 text-xl md:text-2xl font-light leading-relaxed italic mb-8">
              Obsidian Bespoke Experiences was born as an answer to combining our love for Central American history, landscape and culture with the sincere joy of sharing wonderful moments with visitors, from near and far, in a family friendly, wholesome and edifying environment.
            </motion.p>
            <motion.div variants={fadeUp} className="w-12 h-px bg-[#C5A059] mb-8" />
            <motion.p variants={fadeUp} className="font-sans text-white/50 text-sm leading-relaxed">
              With deep roots in El Salvador and an unwavering commitment to authenticity, we design each experience to reveal the extraordinary beauty, rich history, and warm hospitality that make this land truly unique. Every journey is personal. Every detail, intentional.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
